// extracted by mini-css-extract-plugin
export default {"container":"r1-z","heading":"s1-z","links":"t1-z","copy":"u1-z","subCopy":"v1-z","linksLeft":"w1-z","linksCenter":"x1-z","linksRight":"y1-z","link":"z1-z","onlyLink":"A1-z"};